export const ROOT = "/auth";
export const LOGIN = ROOT + "/login";
export const RESET = ROOT + "/reset";
export const PASSWORD_RESET = RESET + "/:resetId";
export const NOT_FOUND = "/*";
